import ContextualEvaluator from "../../evaluator/ContextualEvaluator"
import LocalEvaluateRequest from "./LocalEvaluateRequest"
import EvaluateResponse from "../../EvaluateResponse"

export default abstract class LocalEvaluator<
  REQ extends LocalEvaluateRequest,
  RESP extends EvaluateResponse
> extends ContextualEvaluator<REQ, RESP> {}
